/** The main buttons of what stands on the tile under me, in the middle at the bottom: Harvest, the hub's card. */
import type { CSSProperties, JSX } from 'react';

import { pressOption, type TileOption } from '@game/options/options';
import type { TileFacts } from '@game/planet/tile';
import { haptic } from '@platform/haptics';
import { ActionFace } from '@ui/components/ActionFace';
import { useGame } from '@ui/hooks';

import { optionLook } from './optionLook';

import './options.css';

export function OptionBar({
  options,
  here,
}: {
  options: readonly TileOption[];
  here: TileFacts;
}): JSX.Element {
  const game = useGame();
  return (
    <div className="options">
      {options.map((option) => {
        const look = optionLook(option, here);
        return (
          <button
            key={option.kind}
            type="button"
            className={`act option${look.color ? ' toned' : ''}`}
            style={look.color ? ({ '--tone': look.color } as CSSProperties) : undefined}
            data-option={option.kind}
            aria-disabled={!look.enabled}
            aria-label={look.aria}
            onClick={() => {
              if (pressOption(game, option)) haptic('select');
            }}
          >
            <ActionFace look={look} />
          </button>
        );
      })}
    </div>
  );
}
